const INDIVIDUAL_CLASSIFICATION = "individual_classification";
const LATEST_POSTS = "latest_posts";

export default {
    INDIVIDUAL_CLASSIFICATION,
    LATEST_POSTS
};
